import React from "react";

import Header from "../../components/dashboard-title";
import DateRange from "../../components/date-range-picker";

/**
 * Date range filter for Activity Feed — same DateRange control as reports.
 */
const ActivityFeedDateFilter = ({ startDate, endDate, onChange }) => {
  const handleChange = (nextStart, nextEnd) => {
    onChange({
      startDate: nextStart ? nextStart.toISOString() : null,
      endDate: nextEnd ? nextEnd.toISOString() : null,
    });
  };

  return (
    <div className="activity-feed-date-filter">
      <div className="d-flex justify-content">
        <Header title="Dates" />
      </div>
      <DateRange
        startDate={startDate ? new Date(startDate) : null}
        endDate={endDate ? new Date(endDate) : null}
        onChange={handleChange}
      />
    </div>
  );
};

export default ActivityFeedDateFilter;
